import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllCollections } from "../../redux/actions/collections.action";
import "../categoriesTree/index.css";

function CollectionNode({
  collection,
  idCollection,
  setIdCollection,
  showCollection,
  setShowCollection,
}) {
  const id = collection.collection_id;
  const title = collection.name;
  const isSelected = idCollection.includes(id);

  const handleSelect = (e) => {
    const { checked } = e.target;
    if (checked) {
      setShowCollection([...showCollection, title]);
      setIdCollection([...idCollection, id]);
    } else {
      setShowCollection(showCollection.filter((n) => n !== title));
      setIdCollection(idCollection.filter((c) => c !== id));
    }
  };

  return (
    <li className="d-tree-node border-0">
      <div className="d-flex align-items-center">
        <input type="checkbox" onChange={handleSelect} checked={isSelected} />
        <div className="col d-flex d-tree-head">{title}</div>
      </div>
    </li>
  );
}

function CollectionPicker({
  idCollection,
  setIdCollection,
  showCollection,
  setShowCollection,
}) {
  const dispatch = useDispatch();
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    dispatch(getAllCollections({ limit: 9999, offset: 0 }))
      .then((res) => {
        if (res?.data?.status === 200) {
          setCollections(res.data.data || []);
        }
      })
      .catch(() => setCollections([]));
  }, [dispatch]);

  if (collections.length === 0) {
    return (
      <div className="container">
        <p className="text-muted small p-3 mb-0">No collections found.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-tree">
        <ul className="d-flex d-tree-container flex-column">
          {collections.map((collection) => (
            <CollectionNode
              key={collection.collection_id}
              collection={collection}
              idCollection={idCollection}
              setIdCollection={setIdCollection}
              showCollection={showCollection}
              setShowCollection={setShowCollection}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default CollectionPicker;
